// deno-lint-ignore-file no-unused-vars

import type { EventTrigger, LinkTrigger, ScheduledTrigger, WebhookTrigger } from "../types";

const eventTrigger: EventTrigger = {
  id: "Ft055EQZ1J2G",
  inputs: {
    channel_id: {
      value: "{{data.channel_id}}",
      locked: false,
      hidden: false,
    },
    message_ts: {
      value: "{{data.message_ts}}",
      locked: false,
      hidden: false,
    },
    reaction: {
      value: "{{data.reaction}}",
      locked: false,
      hidden: false,
    },
    user_id: {
      value: "{{data.user_id}}",
      locked: false,
      hidden: false,
    },
  },
  outputs: {
    "{{event_timestamp}}": {
      type: "slack#/types/timestamp",
      name: "event_timestamp",
      title: "",
      is_required: false,
      description: "",
    },
    "{{type}}": {
      type: "string",
      name: "type",
      enum: ["event", "shortcut", "webhook", "scheduled", "external", "blockkit"],
      title: "Trigger type",
      is_required: true,
      is_hidden: true,
      description: "",
    },
    "{{team_id}}": {
      type: "string",
      name: "team_id",
      title: "",
      is_required: true,
      description: "",
    },
    "{{enterprise_id}}": {
      type: "string",
      name: "enterprise_id",
      title: "",
      is_required: true,
      is_hidden: true,
      nullable: true,
      description: "",
    },
    "{{data.user_id}}": {
      type: "slack#/types/user_id",
      name: "user_id",
      title: "",
      is_required: false,
      description: "",
    },
    "{{data.message_ts}}": {
      type: "string",
      name: "message_ts",
      title: "",
      is_required: false,
      description: "",
    },
    "{{data.channel_id}}": {
      type: "slack#/types/channel_id",
      name: "channel_id",
      title: "",
      is_required: false,
      description: "",
    },
    "{{data.reaction}}": {
      type: "string",
      name: "reaction",
      title: "The reaction used",
      is_required: false,
      description: "The reaction used",
    },
    "{{data.message_context}}": {
      type: "slack#/types/message_context",
      name: "message_context",
      title: "",
      is_required: true,
      description: "",
    },
    "{{data.message_link}}": {
      type: "string",
      name: "message_link",
      title: "",
      is_required: false,
      description: "",
    },
    "{{data.parent_message_link}}": {
      type: "string",
      name: "parent_message_link",
      title: "",
      is_required: false,
      description: "",
    },
    "{{data.item_user}}": {
      type: "slack#/types/user_id",
      name: "item_user",
      title: "",
      is_required: false,
      description: "",
    },
  },
  available_data: {
    "{{event_timestamp}}": {
      type: "slack#/types/timestamp",
      name: "event_timestamp",
      title: "",
      is_required: false,
      description: "",
    },
    "{{type}}": {
      type: "string",
      name: "type",
      enum: ["event", "shortcut", "webhook", "scheduled", "external", "blockkit"],
      title: "Trigger type",
      is_required: true,
      is_hidden: true,
      description: "",
    },
    "{{team_id}}": {
      type: "string",
      name: "team_id",
      title: "",
      is_required: true,
      description: "",
    },
    "{{enterprise_id}}": {
      type: "string",
      name: "enterprise_id",
      title: "",
      is_required: true,
      is_hidden: true,
      nullable: true,
      description: "",
    },
    "{{data.user_id}}": {
      type: "slack#/types/user_id",
      name: "user_id",
      title: "",
      is_required: false,
      description: "",
    },
    "{{data.message_ts}}": {
      type: "string",
      name: "message_ts",
      title: "",
      is_required: false,
      description: "",
    },
    "{{data.channel_id}}": {
      type: "slack#/types/channel_id",
      name: "channel_id",
      title: "",
      is_required: false,
      description: "",
    },
    "{{data.reaction}}": {
      type: "string",
      name: "reaction",
      title: "The reaction used",
      is_required: false,
      description: "The reaction used",
    },
    "{{data.message_context}}": {
      type: "slack#/types/message_context",
      name: "message_context",
      title: "",
      is_required: true,
      description: "",
    },
    "{{data.message_link}}": {
      type: "string",
      name: "message_link",
      title: "",
      is_required: false,
      description: "",
    },
    "{{data.parent_message_link}}": {
      type: "string",
      name: "parent_message_link",
      title: "",
      is_required: false,
      description: "",
    },
    "{{data.item_user}}": {
      type: "slack#/types/user_id",
      name: "item_user",
      title: "",
      is_required: false,
      description: "",
    },
  },
  date_created: 1682647277,
  date_updated: 1682647277,
  owning_team_id: "T03E94MJU",
  type: "event",
  event_type: "slack#/events/reaction_added",
  name: "Trigger the example workflow",
  description: "",
  channel_ids: ["C03E94MKS"],
  workflow: {
    id: "Fn055QV87QHF",
    callback_id: "reply-to-reaction-workflow",
    title: "Reply to Reaction Workflow",
    description: "",
    type: "workflow",
    input_parameters: [
      {
        type: "slack#/types/channel_id",
        name: "channel_id",
        title: "Channel Id",
        is_required: true,
      },
      {
        type: "slack#/types/user_id",
        name: "user_id",
        title: "User Id",
        is_required: true,
      },
      {
        type: "string",
        name: "message_ts",
        title: "Message Ts",
        is_required: true,
      },
      {
        type: "string",
        name: "reaction",
        title: "Reaction",
        is_required: true,
      },
    ],
    output_parameters: [],
    app_id: "A05621NTE0G",
    app: {
      id: "A05621NTE0G",
      name: "deno-code-snippets (local)",
      icons: {
        image_32: "",
        image_48: "",
        image_64: "",
        image_72: "",
      },
      is_workflow_app: false,
    },
    date_created: 1682647251,
    date_updated: 1682647251,
    date_deleted: 0,
    workflow_id: "Wf0555NAQAUE",
  },
};

const linkTrigger: LinkTrigger = {
  id: "Ft0559CQETE1",
  inputs: {
    channel_id: {
      value: "{{data.channel_id}}",
      locked: false,
      hidden: false,
    },
  },
  outputs: {
    "{{event_timestamp}}": {
      type: "slack#/types/timestamp",
      name: "event_timestamp",
      title: "",
      is_required: false,
      description: "",
    },
    "{{type}}": {
      type: "string",
      name: "type",
      enum: ["event", "shortcut", "webhook", "scheduled", "external", "blockkit"],
      title: "Trigger type",
      is_required: true,
      is_hidden: true,
      description: "",
    },
    "{{team_id}}": {
      type: "string",
      name: "team_id",
      title: "",
      is_required: true,
      description: "",
    },
    "{{enterprise_id}}": {
      type: "string",
      name: "enterprise_id",
      title: "",
      is_required: true,
      is_hidden: true,
      nullable: true,
      description: "",
    },
    "{{data.user_id}}": {
      type: "slack#/types/user_id",
      name: "user_id",
      title: "Person who ran this workflow",
      is_required: true,
      description: "Person who ran this workflow",
    },
    "{{data.channel_id}}": {
      type: "slack#/types/channel_id",
      name: "channel_id",
      title: "Channel where the workflow was run",
      is_required: false,
      description: "Channel where the workflow was run, if available",
    },
    "{{data.interactivity}}": {
      type: "slack#/types/interactivity",
      name: "interactivity",
      title: "Interactivity context",
      is_required: true,
      description: "Interactivity context",
      is_hidden: true,
    },
  },
  available_data: {
    "{{event_timestamp}}": {
      type: "slack#/types/timestamp",
      name: "event_timestamp",
      title: "",
      is_required: false,
      description: "",
    },
    "{{type}}": {
      type: "string",
      name: "type",
      enum: ["event", "shortcut", "webhook", "scheduled", "external", "blockkit"],
      title: "Trigger type",
      is_required: true,
      is_hidden: true,
      description: "",
    },
    "{{team_id}}": {
      type: "string",
      name: "team_id",
      title: "",
      is_required: true,
      description: "",
    },
    "{{enterprise_id}}": {
      type: "string",
      name: "enterprise_id",
      title: "",
      is_required: true,
      is_hidden: true,
      nullable: true,
      description: "",
    },
    "{{data.user_id}}": {
      type: "slack#/types/user_id",
      name: "user_id",
      title: "Person who ran this workflow",
      is_required: true,
      description: "Person who ran this workflow",
    },
    "{{data.channel_id}}": {
      type: "slack#/types/channel_id",
      name: "channel_id",
      title: "Channel where the workflow was run",
      is_required: false,
      description: "Channel where the workflow was run, if available",
    },
    "{{data.interactivity}}": {
      type: "slack#/types/interactivity",
      name: "interactivity",
      title: "Interactivity context",
      is_required: true,
      description: "Interactivity context",
      is_hidden: true,
    },
  },
  date_created: 1682647436,
  date_updated: 1682647436,
  owning_team_id: "T03E94MJU",
  type: "shortcut",
  name: "MySendMessage Workflow Trigger",
  description: "",
  shortcut_url: "",
  workflow: {
    id: "Fn0559CEPPK7",
    callback_id: "my-send-message-workflow",
    title: "MySendMessage Workflow",
    description: "",
    type: "workflow",
    input_parameters: [
      {
        type: "slack#/types/channel_id",
        name: "channel_id",
        description: "",
        title: "Channel Id",
        is_required: true,
      },
    ],
    output_parameters: [],
    app_id: "A05621NTE0G",
    app: {
      id: "A05621NTE0G",
      name: "deno-code-snippets (local)",
      icons: {
        image_32: "",
        image_48: "",
        image_64: "",
        image_72: "",
      },
      is_workflow_app: false,
    },
    date_created: 1682647251,
    date_updated: 1682647251,
    date_deleted: 0,
    workflow_id: "Wf05621NU5CY",
  },
};

const scheduledTrigger: ScheduledTrigger = {
  id: "Ft055R0TAX8R",
  inputs: {},
  outputs: {
    "{{event_timestamp}}": {
      type: "slack#/types/timestamp",
      name: "event_timestamp",
      title: "",
      is_required: false,
      description: "",
    },
    "{{type}}": {
      type: "string",
      name: "type",
      enum: ["event", "shortcut", "webhook", "scheduled", "external", "blockkit"],
      title: "Trigger type",
      is_required: true,
      is_hidden: true,
      description: "",
    },
    "{{team_id}}": {
      type: "string",
      name: "team_id",
      title: "",
      is_required: true,
      description: "",
    },
    "{{enterprise_id}}": {
      type: "string",
      name: "enterprise_id",
      title: "",
      is_required: true,
      is_hidden: true,
      nullable: true,
      description: "",
    },
  },
  available_data: {
    "{{event_timestamp}}": {
      type: "slack#/types/timestamp",
      name: "event_timestamp",
      title: "",
      is_required: false,
      description: "",
    },
    "{{type}}": {
      type: "string",
      name: "type",
      enum: ["event", "shortcut", "webhook", "scheduled", "external", "blockkit"],
      title: "Trigger type",
      is_required: true,
      is_hidden: true,
      description: "",
    },
    "{{team_id}}": {
      type: "string",
      name: "team_id",
      title: "",
      is_required: true,
      description: "",
    },
    "{{enterprise_id}}": {
      type: "string",
      name: "enterprise_id",
      title: "",
      is_required: true,
      is_hidden: true,
      nullable: true,
      description: "",
    },
  },
  date_created: 1682647944,
  date_updated: 1682647944,
  owning_team_id: "T03E94MJU",
  type: "scheduled",
  schedule: {
    start_time: "2023-04-28T02:12:29.120Z",
    timezone: "UTC",
    frequency: { type: "once" },
  },
  name: "Schedule Workflow Trigger",
  description: "",
  workflow: {
    id: "Fn054XQ8KN07",
    callback_id: "scheduled-workflow",
    title: "Scheduled Workflow",
    description: "",
    type: "workflow",
    input_parameters: [],
    output_parameters: [],
    app_id: "A05621NTE0G",
    app: {
      id: "A05621NTE0G",
      name: "deno-code-snippets (local)",
      icons: {
        image_32: "",
        image_48: "",
        image_64: "",
        image_72: "",
      },
      is_workflow_app: false,
    },
    date_created: 1682647251,
    date_updated: 1682647251,
    date_deleted: 0,
    workflow_id: "Wf055CASPWBU",
  },
};

const webhookTrigger: WebhookTrigger = {
  id: "Ft0559DGDWJ1",
  inputs: {
    channel_id: {
      value: "{{data.channel_id}}",
      locked: false,
      hidden: false,
    },
  },
  outputs: {
    "{{event_timestamp}}": {
      type: "slack#/types/timestamp",
      name: "event_timestamp",
      title: "",
      is_required: false,
      description: "",
    },
    "{{type}}": {
      type: "string",
      name: "type",
      enum: ["event", "shortcut", "webhook", "scheduled", "external", "blockkit"],
      title: "Trigger type",
      is_required: true,
      is_hidden: true,
      description: "",
    },
    "{{team_id}}": {
      type: "string",
      name: "team_id",
      title: "",
      is_required: true,
      description: "",
    },
    "{{enterprise_id}}": {
      type: "string",
      name: "enterprise_id",
      title: "",
      is_required: true,
      is_hidden: true,
      nullable: true,
      description: "",
    },
  },
  available_data: {
    "{{event_timestamp}}": {
      type: "slack#/types/timestamp",
      name: "event_timestamp",
      title: "",
      is_required: false,
      description: "",
    },
    "{{type}}": {
      type: "string",
      name: "type",
      enum: ["event", "shortcut", "webhook", "scheduled", "external", "blockkit"],
      title: "Trigger type",
      is_required: true,
      is_hidden: true,
      description: "",
    },
    "{{team_id}}": {
      type: "string",
      name: "team_id",
      title: "",
      is_required: true,
      description: "",
    },
    "{{enterprise_id}}": {
      type: "string",
      name: "enterprise_id",
      title: "",
      is_required: true,
      is_hidden: true,
      nullable: true,
      description: "",
    },
  },
  date_created: 1682648002,
  date_updated: 1682648002,
  owning_team_id: "T03E94MJU",
  type: "webhook",
  name: "Channel Messaging Workflow Trigger",
  description: "",
  webhook_url: "",
  workflow: {
    id: "Fn0559CEPP53",
    callback_id: "channel-message-workflow",
    title: "Channel Message Workflow",
    description: "",
    type: "workflow",
    input_parameters: [
      {
        type: "slack#/types/channel_id",
        name: "channel_id",
        description: "",
        title: "Channel Id",
        is_required: true,
      },
    ],
    output_parameters: [],
    app_id: "A05621NTE0G",
    app: {
      id: "A05621NTE0G",
      name: "deno-code-snippets (local)",
      icons: {
        image_32: "",
        image_48: "",
        image_64: "",
        image_72: "",
      },
      is_workflow_app: false,
    },
    date_created: 1682647251,
    date_updated: 1682647251,
    date_deleted: 0,
    workflow_id: "Wf05621NU28Y",
  },
};
